import {EquipmentData, ControlledFormField, FormFieldBase} from '@hconnect/common/types'
import {getEquipmentIdType} from '@hconnect/common/utils'
import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import {MainEquipmentSearchHierarchy} from '@widgets/common-shift-event'
import {Controller, FieldValues} from 'react-hook-form'

import {useFormInputLabelWithSuffix} from '../../hooks'

type Props<TField extends FieldValues> = FormFieldBase &
  ControlledFormField<TField> & {
    plantId: string
    onChange?: (value: EquipmentData | undefined) => void
  }

export const MainEquipmentSearchField = <TField extends FieldValues>(props: Props<TField>) => {
  const shouldShowExtendedEquipmentId =
    useCommonFeatureFlag(FeatureFlagKey.ExtendedEquipmentIds, {
      plantId: props.plantId
    }) ?? false
  const equipmentIdType = getEquipmentIdType(!!shouldShowExtendedEquipmentId)
  const {label, optional} = props
  const inputLabel = useFormInputLabelWithSuffix({label, optional})

  return (
    <Controller
      name={props.name}
      control={props.control}
      disabled={props.disabled || props.readOnly}
      render={({field, fieldState}) => (
        <MainEquipmentSearchHierarchy
          plantId={props.plantId}
          label={inputLabel}
          value={field.value}
          required={!props.optional}
          onChange={(value) => {
            field.onChange(value)
            props.onChange?.(value)
          }}
          disabled={props.disabled}
          errorText={fieldState.error?.message}
          idType={equipmentIdType}
        />
      )}
    />
  )
}
